import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=5d8c1c24&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c1c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8c1c24')) {
      api.createRecord('5d8c1c24', component.options)
    } else {
      api.reload('5d8c1c24', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=5d8c1c24&scoped=true&", function () {
      api.rerender('5d8c1c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/PageHeader.vue"
export default component.exports